import type { FC } from "react";
import { useCustomerWithId } from "../../customers/useCustomerWithId";
import AgentSelect from "../../sharedComponents/agentSelect/AgentSelect";

interface Props {
  readonly value: string | undefined;
  readonly customerId: string;
  readonly onChange: (agentId: string | undefined) => void;
}

const SupervisorSelect: FC<Props> = ({ value, customerId, onChange }) => {
  const { customer } = useCustomerWithId(customerId);
  const defaultSupervisor = customer?.accountManager;

  const handleSupervisorChange = (agentId: string | null) => {
    if (agentId === null) {
      onChange(undefined);
    } else {
      onChange(defaultSupervisor?.id === agentId ? undefined : agentId);
    }
  };

  return (
    <AgentSelect
      agentId={value ?? defaultSupervisor?.id ?? null}
      defaultAgentId={defaultSupervisor?.id}
      onChange={handleSupervisorChange}
    />
  );
};

export default SupervisorSelect;
